<template>
  <!-- 作品组件 -->
  <view class="body_" v-on:mouseenter="bodyMouseover()" v-on:mouseleave="bodyMouseout">
    <view class="SL_CB_list_top" @click.stop="DetailsOfWorksClick(item)">
      <view>
        <!-- <img class="SLCB_list_top_hot" src="../assets/publick_zptj2.png" /> -->
        <span v-if="item.isCheck == 0 || item.isCheck == 2"
          style="position: absolute;left: 0.17rem;top: 0.15rem;background:rgba(000, 000, 000, 0.5);border-radius:4px;color: #FFF;height: 20px; text-align: center;line-height: 20px;padding: 0 5px;">{{
            item.isCheck ==
            0 ? "审核中" : "审核驳回" }}</span>
        <span v-if="item.videoDefinition" v-show="immigrationChecked == false" class="SLCB_list_top_definition">{{
          item.videoDefinition }}</span>
        <span v-show="immigrationChecked == true" class="SLCB_list_top_definition_list">
          <img @click="($event) => iconClicked($event)" v-on:mouseover="bodyMouseover" src="../assets/icon_sgd.png" />
          <view v-show="iconChecked == true" class="SLCB_functionList">
            <!-- functionList -->
            <view @click.stop="SLCB_bj()">编辑</view>
            <!-- <view @click="SLCB_kjfw()">可见范围</view> -->
            <!-- <view @click="SLCB_yc()">隐藏</view> -->
            <view @click.stop="SLCB_SJ()">上架状态</view>
            <view @click.stop="SLCB_sc()" style="color: #f05a57">删除</view>
          </view>
        </span>
        <view class="SLCB_list_top_button" @click="DetailsOfWorksClick(item)">
          <view>
            <span class="SLTB_bf">
              <img src="../assets/index_bfl.png" />
              <text>{{ item.plays }}</text>
            </span>
            <span class="SLTB_dz">
              <img src="../assets/index_dzl.png" />
              <text>{{ item.likes }}</text>
            </span>
          </view>
          <view class="SLTB_time" @click="DetailsOfWorksClick(item)">
            {{ item.videoTime }}
            <!-- {{
              com_date.com_date.timestamp_string(
                item.createTime,
                true,
                "-",
                ":"
              )
            }} -->
          </view>
        </view>
      </view>
      <img @click.stop="DetailsOfWorksClick(item)" :src="item.coverSheet"
        style="width: 305px; height: 180px; z-index: 999" />
    </view>
    <p class="SL_CB_list_title" @click="DetailsOfWorksClick(item)">
      {{ item.title }}
    </p>
    <div style="display: flex;justify-content: space-between;align-items: center;column-gap: 5px;">
      <p class="SL_CB_list_type" style="flex: 1;" @click="DetailsOfWorksClick(item)">
        {{ item.category1 }}-{{ item.category2 }}
        {{ item.publishAddress ? item.publishAddress : "未知" }}
        {{ com_date.com_date.timestamp_string(item.createTime, true, "-", ":") }}
      </p>
      <div v-if="item.isCheck == 2 && item.checkMsg" @click="causeBtn(item)"
        style="color:  rgb(237 23 25);display: flex;align-items: center;cursor: pointer;">
        <span>驳回原因</span>
        <el-icon>
          <ArrowRightBold />
        </el-icon>
      </div>
    </div>

    <!-- 作品弹窗组件 上架-->
    <el-dialog v-model="muk_listing" title="上架状态" class="muk_ kejianfangwei" align-center :before-close="handleCloseCard"
      :close-on-click-modal="false" :show-close="false" @click.stop="muk_listing = true" width="4.8rem">
      <template v-slot:header>
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <span>上架状态</span>
          <img @click.stop="muk_listing = false" style="width: 20px; height: 20px; margin-right: 10px"
            :src="require('@/assets/module_share_open.png')" alt="自定义图片" />
        </div>
      </template>

      <div class="muk_listing_title">请选择上架状态</div>
      <el-radio-group v-model="from_muk_listing">
        <el-radio :label="0" :value="0">上架</el-radio>
        <el-radio :label="1" :value="1">下架</el-radio>
      </el-radio-group>
      <div class="dialog_b">
        <div class="dialog_b_qx" @click.stop="muk_listing = false">取消</div>
        <div class="dialog_b_qd" @click.stop="frommuklistingOk">确定</div>
      </div>
    </el-dialog>
    <!-- 作品弹窗组件 编辑 -->
    <el-dialog :close-on-click-modal="false" v-model="muk_edit" title="" class="member_box"
      width="10rem">ceshi</el-dialog>
    <!-- 作品弹窗组件 隐藏 -->
    <el-dialog v-model="muk_displayNone" :show-close="false" :close-on-click-modal="false" title="" align-center
      width="480px" @click.stop="muk_displayNone = true">
      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        确定隐藏此作品
      </div>
      <div style="font-size: 0.14rem; text-align: center; color: #86909c">
        设置隐藏后，你的作品将不会产生任何曝光
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click.stop="muk_displayNone = false">
          取消
        </div>
        <div class="dataBtnSubmit">确认</div>
      </div>
    </el-dialog>

    <!-- 作品弹窗组件 删除 -->
    <el-dialog title="" :show-close="false" :close-on-click-modal="false" v-model="muk_delete" align-center width="480px"
      @click.stop="muk_delete = true">
      <div style="display: flex; justify-content: space-between">
        <div></div>
        <!-- 空容器，用于让标题居中 -->

        <div style="display: flex; align-items: center">
          <img @click.stop="muk_delete = false" style="width: 20px; height: 20px; margin-right: 10px"
            :src="require('@/assets/module_share_open.png')" alt="自定义图片" />
        </div>
      </div>

      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%; height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        确定删除此作品
      </div>

      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click.stop="muk_delete = false">取消</div>
        <div class="dataBtnSubmit" @click.stop="muk_deleteSubiue">确认</div>
        <!-- 用于显示自定义按钮文字的变量 -->
      </div>
    </el-dialog>
  </view>
  <details-of-works ref="DetailsOfWorksRef" :CloseQrCode="CloseQrCode" />
</template>

<script setup>
import { ref, defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import com_date from "@/assets/js/common.js";
import DetailsOfWorks from "@/views/ShadowUser/components/DetailsOfWorks.vue";
import { Axios } from "@/assets/js/ls_com_axios.js";

const router = useRouter();
const props = defineProps({
  item: {
    type: Object,
  },
  CloseQrCode1: {
    type: Function,
    required: true,
  },
});
const emit = defineEmits(["ParticularsOverYse", "update:muk_edit"]);
// 作品状态 弹窗组件
let muk_edit = ref(false);
let muk_see = ref(false);
const from_muk_see = ref(0);
let muk_displayNone = ref(false);
let muk_delete = ref(false);
let immigrationChecked = ref(false); // 鼠标移入单模块触发
let iconChecked = ref(false);
let muk_listing = ref(false);
let from_muk_listing = ref(1);
const DetailsOfWorksRef = ref();
from_muk_listing.value = props.item.upDownState;
const DetailsOfWorksClick = (item) => {
  DetailsOfWorksRef.value.init(item.id);
};
const CloseQrCode = () => { };
const handleCloseCard = () => {
  muk_listing.value = false;
};
const bodyMouseover = function () {
  // console.log(props.item.createUserId);
  //判断是不是本人作品
  if (
    JSON.parse(localStorage.getItem("userList")).memberId ==
    props.item.createUserId
  ) {
    immigrationChecked.value = true;
    if (iconChecked.value == true) {
      iconChecked.value = false;
    }
  } else {
    iconChecked.value = false;
  }
};
const bodyMouseout = function () {
  immigrationChecked.value = false;
};
const causeBtn = (item) => {

  ElMessageBox.confirm(
    item.checkMsg == null ? "审批拒绝" : item.checkMsg,
    '驳回原因',
    {
      confirmButtonText: '确认',
      cancelButtonText: 'Cancel',
      type: 'warning',
      closeOnClickModal: false,
      customClass: 'ShadowUser_ShowActivity',
    }
  )
    .then(() => {
    }).catch(() => {
    })
}
const iconClicked = function (event) {
  event.stopPropagation();
  iconMouseover();
};
const iconMouseover = function () {
  iconChecked.value = true;
};
const SLCB_bj = function () {
  //编辑
  // console.log(121);
  // router.push("/uploadData");
  router.push({ path: "/uploadData", query: { id: props.item.id } });

  // return;
  // muk_edit.value = true;
  // iconChecked.value = false;
};
// const addCount:() => void = () => {
//       emit('update:count', props.count + 1)
//   }
const SLCB_kjfw = function () {
  //可见范围
  muk_see.value = true;
  iconChecked.value = false;
};
const SLCB_yc = function () {
  //隐藏
  iconChecked.value = false;
  muk_displayNone.value = true;
};
const SLCB_SJ = function () {
  //分享
  iconChecked.value = false;
  muk_listing.value = true;
  // iconChecked.value = false;
  // emit("ParticularsOverYse");
};
const SLCB_sc = function () {
  //删除
  iconChecked.value = false;
  muk_delete.value = true;
};
// 除悬浮以外的地方
const printMessage = function () {
  console.log(212);
};
const muk_deleteSubiue = function () {
  // material / material / work / del;
  muk_delete.value = false;
  console.log("props", props.CloseQrCode1);
  if (typeof props.CloseQrCode1 === "function") {
    Axios(
      "post",
      "/material/material/work/del",
      [props.item.id],
      false,
      function (res) {
        muk_delete.value = false;
        ElMessage.success("删除成功");
        props.CloseQrCode1();
      }
    );
  }
};
const frommuklistingOk = function () {
  muk_listing.value = false;
  console.log("props", props.CloseQrCode1);
  let obj = { ...props.item };
  obj.upDownState = from_muk_listing.value;
  if (typeof props.CloseQrCode1 === "function") {
    Axios("post", "/material/material/work/upDown", obj, false, function (res) {
      muk_listing.value = false;
      ElMessage.success("修改成功");
      props.CloseQrCode1();
    });
  }
};
</script>
<style  lang="less">
.ShadowUser_ShowActivity .el-message-box__status.el-message-box-icon--warning {
  font-size: 60px !important;
}

.ShadowUser_ShowActivity .el-message-box__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ShadowUser_ShowActivity .el-message-box__btns>button:nth-of-type(1) {
  display: none;
}

.ShadowUser_ShowActivity {
  border-radius: 12px !important;
}

.ShadowUser_ShowActivity .el-message-box__btns {
  button {
    width: 100%;
    height: 38px;
    line-height: 38px !important;
    text-align: center;
    background: #2978ff !important;
    line-height: 32px;
  }
}
</style>
<style scoped>
@import url(/src/assets/css/com.css);



.body_ {
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  /* padding: 0.08rem; */
  margin-bottom: 0.16rem;
  display: block;
}

.body:hover {
  box-shadow: 0rem 0.02rem 0.12rem 0rem rgba(75, 82, 98, 0.25);
}

.SL_CB_list_top {
  display: block;
  position: relative;
  border-radius: 0.12rem;
}

.SL_CB_list_top>img {
  width: 100%;
  border-radius: 0.12rem;
  overflow: hidden;
}

.SL_CB_list_top>view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.12rem;
}

.SLCB_list_top_hot {
  width: 0.22rem;
  height: 0.22rem;
  position: absolute;
  top: 0.12rem;
  left: 0.16rem;
}

.SLCB_list_top_definition {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
  padding: 0.02rem 0.06rem;
  background: rgba(51, 51, 51, 0.5);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  color: #fff;
}

.SLCB_list_top_definition_list {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
}

.SLCB_list_top_definition_list>img {
  width: 0.24rem;
  background: #fff;
  border-radius: 0.02rem;
  padding: 0.02rem;
}

.SLCB_functionList {
  position: absolute;
  bottom: -0.96rem;
  left: -0.75rem;
  background: #fff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.04rem;
  width: 1rem;
  z-index: 1;
}

.SLCB_functionList>view {
  display: block;
  color: #333333;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.06rem 0;

  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
}

.SLCB_functionList>view:hover {
  background: #f0f1f1;
}

.SLCB_list_top_button {
  width: calc(100% + 0.06rem);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0.14rem 0.16rem;
  border-radius: 0.12rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
}

.SLTB_bf,
.SLTB_dz,
.SLCB_list_top_button>view {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.SLTB_bf {
  margin-right: 0.2rem;
}

.SLTB_bf>img,
.SLTB_dz>img {
  width: 0.14rem;
  margin-right: 0.04rem;
}

.SLTB_bf>text,
.SLTB_dz>text {
  font-size: 0.12rem;
  color: #ffffff;
}

.SLTB_time {
  color: #fff;
  font-size: 0.12rem;
}

.SL_CB_list_title {
  font-size: 0.14rem;
  color: #000;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 0.12rem;
}

.SL_CB_list_type {
  font-size: 0.12rem;
  color: #86909c;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 0.04rem;
}

.SL_CB_list_user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.12rem;
}

.SL_CB_list_user_img {
  width: 0.24rem;
  margin-right: 0.08rem;
}

.SL_CB_list_user_name {
  font-size: 0.12rem;
  color: #000;
  margin-right: 0.08rem;
}

.SL_CB_list_user_hy1,
.SL_CB_list_user_hy2 {
  width: 0.16rem;
  margin-right: 0.06rem;
}

/deep/.muk_ {
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  background: #ffffff;
  padding: 0.18rem 0.26rem;
}

/deep/.el-dialog__header {
  /* padding: 0rem; */
  padding-bottom: 0;
  margin-right: 0;
  color: #333333;
  font-size: 0.16rem;
}

/deep/ .kejianfangwei .el-dialog__header {
  padding: 0rem;
}

/deep/.el-dialog__body {
  padding: 0;
}

.muk_see_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.16rem;
  margin-top: 0.21rem;
}

.dialog_b {
  margin-top: 0.2rem;
  display: flex;
  justify-content: center;
}

.dialog_b_qx {
  padding: 0.08rem 0.3rem;
  background: #fff;
  border: 0.01rem solid #333333;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-right: 0.2rem;
  color: #333333;
  font-size: 0.14rem;
}

.dialog_b_qd {
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.08rem 0.3rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.3rem;
}

/deep/.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #c01a26 !important;
  background: #c01a26 !important;
}
</style>
